import { Injectable } from '@angular/core';
import { ApolloService } from '../services/apollo.service';

@Injectable({
  providedIn: 'root',
})
export class UserTrackingService {
  constructor(private apolloService: ApolloService) { }

  updateUserTrackingData(input: { country: string }) {
    const query = `
      mutation updateUserTrackingData($input: UserTrackingInput) {
        updateUserTrackingData(input: $input) {
          success
          statusCode
          message
        }
      }
    `;
    return this.apolloService.mutate(query, { "input": input });
  }

  updateUserTrackingLogout() {
    const query = `
      mutation updateUserTrackingLogout {
        updateUserTrackingLogout {
          success
          statusCode
          message
        }
      }
    `;
    return this.apolloService.mutate(query, {});
  }

}